import type {
  RequestLogLastHours,
  RequestLogOrderBy,
  RequestLogStatus,
  RequestLogsListInput,
} from '@travel-planner/shared/schemas';

export const REQUEST_LOGS_PAGE_SIZE = 10;

export type MonitorSearch = {
  lastHours?: RequestLogLastHours;
  status?: RequestLogStatus;
  search?: string;
  userRef?: string;
  page?: number;
  orderBy?: RequestLogOrderBy;
  order?: 'asc' | 'desc';
};

const asLastHours = (v: unknown): RequestLogLastHours | undefined => {
  if (v === 1 || v === 12 || v === 24) return v;
  if (typeof v === 'string') {
    const n = Number(v);
    if (n === 1 || n === 12 || n === 24) return n;
  }
  return undefined;
};

const asStatus = (v: unknown): RequestLogStatus | undefined =>
  v === 'success' || v === 'failure' ? v : undefined;

const asOrderBy = (v: unknown): RequestLogOrderBy | undefined =>
  v === 'startTime' || v === 'duration' || v === 'responseHttpCode'
    ? v
    : undefined;

const asOrder = (v: unknown): 'asc' | 'desc' | undefined =>
  v === 'asc' || v === 'desc' ? v : undefined;

const asString = (v: unknown): string | undefined =>
  typeof v === 'string' && v.length > 0 ? v : undefined;

const asPage = (v: unknown): number | undefined => {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isInteger(n) && n >= 1 ? n : undefined;
};

export const validateMonitorSearch = (
  input: Record<string, unknown>
): MonitorSearch => ({
  lastHours: asLastHours(input.lastHours),
  status: asStatus(input.status),
  search: asString(input.search),
  userRef: asString(input.userRef),
  page: asPage(input.page),
  orderBy: asOrderBy(input.orderBy),
  order: asOrder(input.order),
});

export const toListInput = (search: MonitorSearch): RequestLogsListInput => {
  const page = search.page ?? 1;
  return {
    offset: (page - 1) * REQUEST_LOGS_PAGE_SIZE,
    limit: REQUEST_LOGS_PAGE_SIZE,
    lastHours: search.lastHours,
    status: search.status,
    search: search.search,
    userRef: search.userRef,
    orderBy: search.orderBy ?? 'startTime',
    order: search.order ?? 'desc',
  };
};
